"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumSize = exports.useIconColor = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const IconWrapper_types_1 = require("./IconWrapper.types");
const useIconColor = ({ color }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    if (color === IconWrapper_types_1.IconColor.Alert ||
        color === IconWrapper_types_1.IconColor.AlertLight ||
        color === IconWrapper_types_1.IconColor.DisableDark ||
        color === IconWrapper_types_1.IconColor.DisableLight ||
        color === IconWrapper_types_1.IconColor.Fail ||
        color === IconWrapper_types_1.IconColor.FailLight ||
        color === IconWrapper_types_1.IconColor.Notification ||
        color === IconWrapper_types_1.IconColor.NotificationLight ||
        color === IconWrapper_types_1.IconColor.Success ||
        color === IconWrapper_types_1.IconColor.SuccessLight) {
        return theme.colors.colours.system[color].value;
    }
    if (color === IconWrapper_types_1.IconColor.Support20 ||
        color === IconWrapper_types_1.IconColor.Support40 ||
        color === IconWrapper_types_1.IconColor.Support60 ||
        color === IconWrapper_types_1.IconColor.Support80 ||
        color === IconWrapper_types_1.IconColor.Support100) {
        return theme.colors.colours.support[color].value;
    }
    if (color === IconWrapper_types_1.IconColor.Primary || color === IconWrapper_types_1.IconColor.Secondary || color === IconWrapper_types_1.IconColor.Tertiary) {
        return theme.colors.theme[color].value;
    }
    return theme.colors.colours.default[color].value;
};
exports.useIconColor = useIconColor;
const useNumSize = ({ size }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    return theme.sizes[size].value;
};
exports.useNumSize = useNumSize;
//# sourceMappingURL=iconWrapper.helper.js.map